<template>
  <div v-if="item.items.length > 0">
    <h4
      @click.prevent="handleClick"
      class="flex items-center px-1 transition duration-600 ease-in py-1 text-left "
      :class="{
        'cursor-pointer sidebar-menu-item dark:hover:bg-gray-800':
          displayAsButton,
        'font-bold  text-primary-500 dark:text-primary-400': item.active,
        'font-bold border-b dark:border-b-primary-400 mb-3 text-primary-500 dark:text-primary-400': ! collapsed,
        'text-primary-900 dark:text-[#90a8bb]': collapsed && ! item.active,
      }"
    >
      <span class="inline-block shrink-0 w-6 h-6 text-primary-500 dark:text-primary-400">
        <component
          :is="`x-icon-solid-${item.icon}`"
          height="24"
          width="24"
        />
      </span>

      <span
        class="flex-1 flex items-center w-full font-bold text-left text-xs mx-3 justify-start mt-1"
      >
        {{ item.name }}
      </span>

      <span
        v-if="item.collapsable"
        class="inline-flex items-center justify-center shrink-0 w-6 h-6"
      >
        <CollapseButton :collapsed="collapsed" :to="item.path" />
      </span>
    </h4>

    <div v-if="!collapsed">
      <component
        :key="item.name"
        v-for="item in item.items"
        :is="item.component"
        :item="item"
      />
    </div>
  </div>
</template>

<script>
import { Collapsable } from '@/mixins'

export default {
  mixins: [Collapsable],

  props: ['item'],

  methods: {
    handleClick() {
      if (this.item.collapsable) {
        this.toggleCollapse()
      }
    },
  },

  computed: {
    component() {
      if (this.item.items.length > 0) {
        return 'div'
      }

      return 'h3'
    },

    displayAsButton() {
      return this.item.items.length > 0 && this.item.collapsable
    },

    collapsedByDefault() {
      return this.item?.collapsedByDefault ?? false
    },
  },
}
</script>
